import { render, staticRenderFns } from "./ConversationStatus.vue?vue&type=template&id=37636b96&scoped=true"
import script from "./ConversationStatus.vue?vue&type=script&lang=js"
export * from "./ConversationStatus.vue?vue&type=script&lang=js"
import style0 from "./ConversationStatus.vue?vue&type=style&index=0&id=37636b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37636b96",
  null
  
)

export default component.exports